import { Box, Button, Grid, Typography, useTheme } from '@mui/material'
import { useFormik } from 'formik'
import { ValueSetter } from '~/shared/types'
import { EditField } from '~/shared/ui'
type FormValues = { external_description?: string | null }

interface CaseMemberFacingInfoProps {
  selectedCase: FormValues
  handleSubmit: (values: FormValues) => Promise<void>
  loading: boolean
}

const CaseMemberFacingInfo = ({
  selectedCase,
  handleSubmit,
  loading,
}: CaseMemberFacingInfoProps) => {
  const theme = useTheme()
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: selectedCase,
    onSubmit: handleSubmit,
  })

  const { external_description } = formik.values

  const setValues: ValueSetter = (name, value) => ({
    name,
    onChange: e => {
      e.persist()
      formik.handleChange(e)
      void formik.setFieldTouched(name, true, false)
    },
    disabled: loading,
    value,
  })

  return (
    <Box sx={{ bgcolor: 'background.external', px: 2, py: 1 }}>
      <Typography sx={{ color: 'grey.500', fontSize: '12px', fontWeight: 500 }}>
        Member-Facing Information
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <EditField
            {...setValues('external_description', external_description)}
            label="Member-Facing Title"
            // Assume that if external description is set, it is required on
            // this case. This may not be true of all member-facing case
            // categories in the future.
            required
            variant="outlined"
            size="small"
            disabled={loading}
            slotProps={{
              input: {
                style: { backgroundColor: `${theme.palette.background.default}` },
              },
            }}
          />
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', my: 2 }}>
          {formik.dirty && (
            <Box sx={{ mr: 3 }}>
              <Button onClick={() => formik.resetForm()}>Cancel</Button>
            </Box>
          )}

          <Button
            disabled={!formik.dirty}
            type="submit"
            variant="contained"
            color="primary"
            sx={{
              borderRadius: 24,
            }}
          >
            Save + Update App
          </Button>
        </Box>
      </form>
    </Box>
  )
}

export default CaseMemberFacingInfo
